export enum TrafficSituationTagColor {
  Blue = 'blue',
  Labs = 'labs',
}
